import React from 'react';
import EditProfileTabOption from './EditProfileTabOption';

const EditProfileTabOptions = ({ inputList }) => {
  return (
    <div className="general-options-wrap">
      {
        inputList.map(item => {
          return (
            <EditProfileTabOption
              key={item.id}
              {...item}
            />
          )
        })
      }
    </div>
  )
}

export default EditProfileTabOptions;